export default __webpack_public_path__ + "static/media/negative.b114d7a6.svg";